<template>
	<div class="fsa-overlay" @click="$emit('close')">
		<div class="fsa-modal" @click.stop>
			<!-- 标题栏 -->
			<div class="fsa-header">
				<div class="fsa-header-title">
					<div class="fsa-icon">食</div>
					<span>食品安全分析</span>
				</div>
				<div class="fsa-close" @click="$emit('close')">✕</div>
			</div>

			<!-- 内容区 -->
			<div class="fsa-body">
				<!-- 核心指标卡片 -->
				<div class="fsa-stats">
					<div class="fsa-stat" :class="s.color" v-for="s in stats" :key="s.label">
						<div class="fsa-stat-label">{{ s.label }}</div>
						<div class="fsa-stat-value">{{ s.value }}<span class="fsa-unit">{{ s.unit }}</span></div>
						<div class="fsa-stat-trend" :class="s.trendClass">{{ s.trend }}</div>
					</div>
				</div>

				<!-- 趋势图 -->
				<div class="fsa-chart-section">
					<div class="fsa-section-title">指标月度趋势（{{ trendTitleRange }}）</div>
					<div class="fsa-trend" ref="trendChart"></div>
				</div>

				<!-- 底部两栏：企业排名 + 分析结论 -->
				<div class="fsa-bottom">
					<div class="fsa-rank">
						<div class="fsa-section-title">企业食品安全评分排名</div>
						<div class="fsa-rank-list">
							<div class="fsa-rank-item" v-for="(r, i) in ranks" :key="r.name">
								<div class="fsa-rank-num">{{ i + 1 }}</div>
								<div class="fsa-rank-name">{{ r.name }}</div>
								<div class="fsa-rank-bar-wrap">
									<div class="fsa-rank-bar" :class="r.barClass" :style="{ width: r.score + '%' }"></div>
								</div>
								<div class="fsa-rank-value">{{ r.score }}%</div>
							</div>
						</div>
					</div>

					<div class="fsa-conclusion">
						<div class="fsa-section-title">综合分析</div>
						<ul class="fsa-conclusion-list">
							<li :class="c.type" v-for="(c, i) in conclusions" :key="i">{{ c.text }}</li>
						</ul>
					</div>
				</div>
			</div>

			<!-- 底部状态栏 -->
			<div class="fsa-footer">
				<div class="fsa-update">
					<div class="fsa-dot"></div>
					<span>数据更新时间：{{ updateTime }}</span>
				</div>
				<span>重庆火锅产业大脑 · 社会侧 · 食品安全</span>
			</div>
		</div>
	</div>
</template>

<script>
	import * as echarts from 'echarts'
	export default {
		name: 'FoodSafetyAnalysis',
		data() {
			return {
				trendTitleRange: '2026年1-10月',
				months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月'],
				stats: [{
						label: '抽检合格率',
						value: '97.6',
						unit: '%',
						color: 'blue',
						trendClass: 'down',
						trend: '↓ 0.1% 较上月'
					},
					{
						label: '产品合格率',
						value: '99.2',
						unit: '%',
						color: 'green',
						trendClass: 'down',
						trend: '↓ 0.1% 较上月'
					},
					{
						label: '质量投诉率',
						value: '16.0',
						unit: '%',
						color: 'orange',
						trendClass: 'up',
						trend: '↓ 1.2% 较上月'
					},
					{
						label: '投诉处理率',
						value: '100.0',
						unit: '%',
						color: 'purple',
						trendClass: 'up',
						trend: '↑ 0.3% 较上月'
					}
				],
				ranks: [{
						name: '百洋海味',
						score: 93,
						barClass: 'high'
					},
					{
						name: '港润食品',
						score: 92,
						barClass: 'high'
					},
					{
						name: '杏运宝宝',
						score: 89,
						barClass: 'high'
					},
					{
						name: '武都花椒',
						score: 88,
						barClass: 'high'
					},
					{
						name: '正黔非凡',
						score: 87,
						barClass: 'mid'
					},
					{
						name: '凯鸿食品',
						score: 85,
						barClass: 'mid'
					},
					{
						name: '臻味鲜',
						score: 73,
						barClass: 'low'
					},
					{
						name: '聚椒',
						score: 63,
						barClass: 'low'
					},
					{
						name: '平易粮油',
						score: 61,
						barClass: 'low'
					}
				],
				conclusions: [{
						type: 'good',
						text: '产品合格率持续保持在99%以上高位运行，整体质量稳定可靠。'
					},
					{
						type: 'good',
						text: '投诉处理率全年接近100%，食品安全事件响应及时、处置闭环完善。'
					},
					{
						type: 'warn',
						text: '抽检合格率近两月略有波动，从98.2%降至97.6%，需关注四季度抽检异常批次。'
					},
					{
						type: 'warn',
						text: '8月质量投诉率升至18.5%为年内高点，建议复盘夏季高温期储运环节管控。'
					},
					{
						type: '',
						text: '平易粮油、聚椒等3家企业评分低于70%，建议纳入重点帮扶与专项抽检名单。'
					}
				],
				myChart: null
			}
		},
		computed: {
			// 弹框左下角“数据更新时间”取当前日期
			updateTime() {
				const d = new Date()
				const p = n => (n < 10 ? '0' + n : '' + n)
				return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
			}
		},
		mounted() {
			this.initChart()
			window.addEventListener('resize', this.resize)
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.resize)
			if (this.myChart) {
				this.myChart.dispose()
				this.myChart = null
			}
		},
		methods: {
			resize() {
				if (this.myChart) this.myChart.resize()
			},
			initChart() {
				this.myChart = echarts.init(this.$refs.trendChart)
				const option = {
					tooltip: {
						trigger: 'axis',
						backgroundColor: 'rgba(10, 30, 60, 0.9)',
						borderColor: 'rgba(0, 180, 255, 0.4)',
						textStyle: {
							color: '#cce8ff',
							fontSize: 12
						},
						axisPointer: {
							lineStyle: {
								color: 'rgba(0, 212, 255, 0.5)'
							}
						}
					},
					legend: {
						data: ['抽检合格率', '产品合格率', '质量投诉率', '投诉处理率'],
						textStyle: {
							color: '#88bbdd',
							fontSize: 12
						},
						itemWidth: 14,
						itemHeight: 8,
						top: 0
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						top: 40,
						containLabel: true
					},
					xAxis: {
						type: 'category',
						data: this.months,
						axisLine: {
							lineStyle: {
								color: 'rgba(0, 180, 255, 0.3)'
							}
						},
						axisLabel: {
							color: '#88bbdd',
							fontSize: 11
						}
					},
					yAxis: [{
							type: 'value',
							min: 95,
							max: 102,
							position: 'left',
							axisLine: {
								show: false
							},
							splitLine: {
								lineStyle: {
									color: 'rgba(0, 180, 255, 0.1)'
								}
							},
							axisLabel: {
								color: '#88bbdd',
								fontSize: 11,
								formatter: '{value}%'
							}
						},
						{
							type: 'value',
							min: 0,
							max: 25,
							position: 'right',
							axisLine: {
								show: false
							},
							splitLine: {
								show: false
							},
							axisLabel: {
								color: '#ff9933',
								fontSize: 11,
								formatter: '{value}%'
							}
						}
					],
					series: [{
							name: '抽检合格率',
							type: 'line',
							data: [98.2, 98.1, 98.1, 97.7, 97.6, 98.0, 97.6, 97.5, 97.7, 97.6],
							smooth: true,
							symbol: 'circle',
							symbolSize: 5,
							lineStyle: {
								color: '#00d4ff',
								width: 2
							},
							itemStyle: {
								color: '#00d4ff'
							},
							areaStyle: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: 'rgba(0, 212, 255, 0.25)'
									},
									{
										offset: 1,
										color: 'rgba(0, 212, 255, 0)'
									}
								])
							}
						},
						{
							name: '产品合格率',
							type: 'line',
							data: [99.6, 99.5, 99.5, 99.3, 99.2, 99.4, 99.2, 99.1, 99.3, 99.2],
							smooth: true,
							symbol: 'circle',
							symbolSize: 5,
							lineStyle: {
								color: '#00ff99',
								width: 2
							},
							itemStyle: {
								color: '#00ff99'
							}
						},
						{
							name: '质量投诉率',
							type: 'line',
							yAxisIndex: 1,
							data: [18.0, 17.5, 16.8, 16.2, 16.5, 17.0, 17.5, 18.5, 17.2, 16.0],
							smooth: true,
							symbol: 'circle',
							symbolSize: 5,
							lineStyle: {
								color: '#ff9933',
								width: 2
							},
							itemStyle: {
								color: '#ff9933'
							}
						},
						{
							name: '投诉处理率',
							type: 'line',
							data: [100.0, 99.6, 100.0, 100.0, 99.8, 100.0, 99.5, 99.3, 99.7, 100.0],
							smooth: true,
							symbol: 'circle',
							symbolSize: 5,
							lineStyle: {
								color: '#aa66ff',
								width: 2,
								type: 'dashed'
							},
							itemStyle: {
								color: '#aa66ff'
							}
						}
					]
				}
				this.myChart.setOption(option)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.fsa-overlay {
		position: fixed;
		inset: 0;
		background: rgba(3, 10, 25, 0.75);
		backdrop-filter: blur(4px);
		z-index: 3000;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.fsa-modal {
		position: relative;
		width: 1200px;
		max-width: 95vw;
		max-height: 92vh;
		background: linear-gradient(180deg, rgba(13, 35, 72, 0.95) 0%, rgba(8, 22, 50, 0.98) 100%);
		border: 1px solid rgba(0, 180, 255, 0.35);
		border-radius: 8px;
		box-shadow: 0 0 40px rgba(0, 150, 255, 0.25), inset 0 0 60px rgba(0, 100, 200, 0.08);
		display: flex;
		flex-direction: column;
		overflow: hidden;

		&::before,
		&::after {
			content: '';
			position: absolute;
			width: 24px;
			height: 24px;
			border: 2px solid #00d4ff;
		}

		&::before {
			top: -1px;
			left: -1px;
			border-right: none;
			border-bottom: none;
		}

		&::after {
			bottom: -1px;
			right: -1px;
			border-left: none;
			border-top: none;
		}
	}

	.fsa-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 16px 24px;
		background: linear-gradient(90deg, rgba(0, 150, 255, 0.2) 0%, transparent 100%);
		border-bottom: 1px solid rgba(0, 180, 255, 0.2);
		flex-shrink: 0;
	}

	.fsa-header-title {
		display: flex;
		align-items: center;
		gap: 12px;
		font-size: 20px;
		font-weight: bold;
		color: #fff;
		letter-spacing: 2px;
	}

	.fsa-icon {
		width: 28px;
		height: 28px;
		background: linear-gradient(135deg, #00d4ff, #0066ff);
		border-radius: 4px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		color: #fff;
		box-shadow: 0 0 12px rgba(0, 212, 255, 0.5);
	}

	.fsa-close {
		width: 32px;
		height: 32px;
		border: 1px solid rgba(0, 180, 255, 0.4);
		background: rgba(0, 100, 200, 0.15);
		color: #88ccff;
		border-radius: 4px;
		cursor: pointer;
		font-size: 16px;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: all 0.2s;

		&:hover {
			background: rgba(255, 80, 80, 0.3);
			border-color: rgba(255, 100, 100, 0.6);
			color: #fff;
		}
	}

	.fsa-body {
		padding: 20px 24px;
		overflow-y: auto;
		flex: 1;
	}

	.fsa-stats {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 14px;
		margin-bottom: 16px;
	}

	.fsa-stat {
		background: linear-gradient(135deg, rgba(0, 100, 200, 0.15) 0%, rgba(0, 50, 120, 0.1) 100%);
		border: 1px solid rgba(0, 180, 255, 0.25);
		border-radius: 6px;
		padding: 12px 14px;
		position: relative;
		overflow: hidden;

		&::before {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 3px;
			height: 100%;
		}

		&.blue::before {
			background: #00d4ff;
			box-shadow: 0 0 8px #00d4ff;
		}

		&.green::before {
			background: #00ff99;
			box-shadow: 0 0 8px #00ff99;
		}

		&.orange::before {
			background: #ff9933;
			box-shadow: 0 0 8px #ff9933;
		}

		&.purple::before {
			background: #aa66ff;
			box-shadow: 0 0 8px #aa66ff;
		}
	}

	.fsa-stat-label {
		font-size: 12px;
		color: #88bbdd;
		margin-bottom: 6px;
	}

	.fsa-stat-value {
		font-size: 24px;
		font-weight: bold;
		color: #fff;
		line-height: 1;
		margin-bottom: 5px;
	}

	.fsa-unit {
		font-size: 14px;
		font-weight: normal;
		color: #88bbdd;
		margin-left: 2px;
	}

	.fsa-stat-trend {
		font-size: 12px;

		&.up {
			color: #00ff99;
		}

		&.down {
			color: #ff6666;
		}

		&.neutral {
			color: #88bbdd;
		}
	}

	.fsa-chart-section {
		background: rgba(0, 40, 100, 0.15);
		border: 1px solid rgba(0, 180, 255, 0.2);
		border-radius: 6px;
		padding: 12px 16px;
		margin-bottom: 16px;
	}

	.fsa-section-title {
		font-size: 15px;
		color: #cce8ff;
		margin-bottom: 12px;
		padding-left: 10px;
		border-left: 3px solid #00d4ff;
		letter-spacing: 1px;
	}

	.fsa-trend {
		width: 100%;
		height: 220px;
	}

	.fsa-bottom {
		display: grid;
		grid-template-columns: 1.4fr 1fr;
		gap: 14px;
	}

	.fsa-rank {
		background: rgba(0, 40, 100, 0.15);
		border: 1px solid rgba(0, 180, 255, 0.2);
		border-radius: 6px;
		padding: 16px;
	}

	.fsa-rank-list {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.fsa-rank-item {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.fsa-rank-num {
		width: 20px;
		height: 20px;
		border-radius: 3px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 11px;
		font-weight: bold;
		color: #fff;
		flex-shrink: 0;
		background: rgba(0, 100, 200, 0.4);
		color: #88bbdd;
	}

	.fsa-rank-item:nth-child(1) .fsa-rank-num {
		background: linear-gradient(135deg, #ffd700, #ffaa00);
		color: #333;
	}

	.fsa-rank-item:nth-child(2) .fsa-rank-num {
		background: linear-gradient(135deg, #c0c0c0, #999);
		color: #333;
	}

	.fsa-rank-item:nth-child(3) .fsa-rank-num {
		background: linear-gradient(135deg, #cd7f32, #aa5500);
		color: #fff;
	}

	.fsa-rank-name {
		width: 80px;
		font-size: 13px;
		color: #cce8ff;
		flex-shrink: 0;
	}

	.fsa-rank-bar-wrap {
		flex: 1;
		height: 14px;
		background: rgba(0, 50, 120, 0.4);
		border-radius: 2px;
		overflow: hidden;
		position: relative;
	}

	.fsa-rank-bar {
		height: 100%;
		border-radius: 2px;
		transition: width 1s ease-out;

		&.high {
			background: linear-gradient(90deg, #00aa66, #00ffcc);
			box-shadow: 0 0 8px rgba(0, 255, 204, 0.4);
		}

		&.mid {
			background: linear-gradient(90deg, #0066ff, #00d4ff);
		}

		&.low {
			background: linear-gradient(90deg, #cc6600, #ffaa33);
			box-shadow: 0 0 8px rgba(255, 170, 51, 0.4);
		}
	}

	.fsa-rank-value {
		width: 40px;
		text-align: right;
		font-size: 13px;
		font-weight: bold;
		color: #fff;
		flex-shrink: 0;
	}

	.fsa-conclusion {
		background: rgba(0, 40, 100, 0.15);
		border: 1px solid rgba(0, 180, 255, 0.2);
		border-radius: 6px;
		padding: 16px;
	}

	.fsa-conclusion-list {
		list-style: none;
		display: flex;
		flex-direction: column;
		gap: 12px;
		padding: 0;
		margin: 0;

		li {
			font-size: 13px;
			color: #aaccee;
			line-height: 1.6;
			padding-left: 16px;
			position: relative;

			&::before {
				content: '';
				position: absolute;
				left: 0;
				top: 8px;
				width: 6px;
				height: 6px;
				background: #00d4ff;
				border-radius: 50%;
				box-shadow: 0 0 6px #00d4ff;
			}

			&.warn::before {
				background: #ff9933;
				box-shadow: 0 0 6px #ff9933;
			}

			&.good::before {
				background: #00ff99;
				box-shadow: 0 0 6px #00ff99;
			}
		}
	}

	.fsa-footer {
		padding: 10px 24px;
		border-top: 1px solid rgba(0, 180, 255, 0.15);
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 12px;
		color: #6699bb;
		flex-shrink: 0;
	}

	.fsa-update {
		display: flex;
		align-items: center;
		gap: 6px;
	}

	.fsa-dot {
		width: 6px;
		height: 6px;
		background: #00ff99;
		border-radius: 50%;
		animation: fsaPulse 2s infinite;
	}

	@keyframes fsaPulse {

		0%,
		100% {
			opacity: 1;
		}

		50% {
			opacity: 0.4;
		}
	}

	.fsa-body::-webkit-scrollbar {
		width: 6px;
	}

	.fsa-body::-webkit-scrollbar-track {
		background: rgba(0, 50, 120, 0.2);
	}

	.fsa-body::-webkit-scrollbar-thumb {
		background: rgba(0, 180, 255, 0.3);
		border-radius: 3px;
	}
</style>
